export function DefaultError() {
    return (
        <div className="component-error">
            <h1>Something went wrong</h1>
            <p>In order to solve the problem you need to look into the browser console...</p>
        </div>
    )
}
